// src/components/sections/news.tsx

'use client';

import { BlogPost } from "../../lib/types";
import SwiperGallery from "../ui/SwiperGallery";
import { useInView } from '@/lib/useInView';

interface NewsSectionProps {
  recentPosts: BlogPost[];
}

export default function News({ recentPosts: _ }: NewsSectionProps) {
  const { ref } = useInView<HTMLDivElement>();
  
  // Hardcoded gallery items for external article links
  const galleryItems = [
    {
      id: "1",
      date: "november 2025",
      title: "Storytelling in flux (Part 2): Building a story engine",
      image: "/images/homegallery/5_storytelling1.jpg",
      link: "https://www.linkedin.com/pulse/storytelling-flux-building-story-engine-jonny-leahan-xyije/"
    },
    {
      id: "2",
      date: "october 2025",
      title: "Leading creatives as people, not resources",
      image: "/images/homegallery/6_leading.jpg",
      link: "https://www.linkedin.com/pulse/leading-creatives-people-resources-gaius-benbow-updde"
    },
    {
      id: "3",
      date: "september 2025",
      title: "Storytelling in flux (Part 1): Crafting a unified brand narrative in the age of AI",
      image: "/images/homegallery/7_storytelling2.jpg",
      link: "https://www.linkedin.com/pulse/storytelling-flux-crafting-unified-brand-narrative-age-jonny-leahan-mzj5e/"
    },
    {
      id: "4",
      date: "september 2025",
      title: "AI loves all the things content strategists have been annoying you about for decades",
      image: "/images/homegallery/4_AI-loves.jpg",
      link: "https://www.linkedin.com/pulse/ai-loves-all-things-content-strategists-have-been-annoying-hofstra-lrdtf/"
    },
    {
      id: "5",
      date: "august 2025",
      title: "AI is stealing your audience. Content strategy can win them back.",
      image: "/images/homegallery/2_AI-stealing.jpg",
      link: "https://www.linkedin.com/pulse/ai-stealing-your-audience-content-strategy-can-win-them-kate-hofstra-ylwqe/"
    },
    {
      id: "6",
      date: "august 2025",
      title: "Designing trust: Why CX-led relationships win ",
      image: "/images/homegallery/3_designing.jpg",
      link: "https://www.linkedin.com/pulse/designing-trust-why-cx-led-relationships-win-james-huerta-ml72e/"
    },
    {
      id: "7",
      date: "october 2025",
      title: "5 minutes with… David Shulman ",
      image: "/images/homegallery/1_shu.jpg",
      link: "https://lbbonline.com/news/5-minutes-with-david-shulman/"
    },
  ];

  return (
    <section className="spotlight-section pt-[30px] lg:pt-[3.75rem]">
      <div ref={ref} className="global-padding overflow-hidden animate-in-view">
        <SwiperGallery
          items={galleryItems}
          slidesPerView={4}
          spaceBetween={45}
          autoplay={false}
          scrollbar={true}
          pagination={false}
          className="spotlight-gallery news-gallery"
        />
      </div>

      <style jsx global>{`
        /* Mobile: One card per view with next card peeking through on right */
        @media (max-width: 499px) {
          .news-gallery .swiper-slide {
            width: 95% !important;
          }
        }

        /* Small mobile/tablet: 2 cards per view with third peeking */
        @media (min-width: 500px) and (max-width: 767px) {
          .news-gallery .swiper-slide {
            width: calc((100% - 1.25rem) / 2.15) !important;
          }
        }

        /* Tablet: Responsive width for 2 slides */
        @media (min-width: 768px) and (max-width: 949px) {
          .news-gallery .swiper-slide {
            width: calc((100% - 1.5625rem) / 2) !important;
          }
        }

        /* Desktop: Responsive width for 3 slides */
        @media (min-width: 950px) and (max-width: 1549px) {
          .news-gallery .swiper-slide {
            width: calc((100% - 5.625rem) / 3) !important;
          }
        }

        /* Large Desktop: Responsive width for 4 slides */
        @media (min-width: 1550px) {
          .news-gallery .swiper-slide {
            width: calc((100% - 8.4375rem) / 4) !important;
          }
        }
      `}</style>
    </section>
  );
}